import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import DogInPoolWebp from '../../../assets/images/cartoons/DogInPool.webp';
import DogInPoolPng from '../../../assets/images/cartoons/DogInPool.png';
import PopcornWebp from '../../../assets/images/cartoons/Popcorn.webp';
import PopcornPng from '../../../assets/images/cartoons/Popcorn.png';
import ClapWebp from '../../../assets/images/cartoons/Clap.webp';
import ClapPng from '../../../assets/images/cartoons/Clap.png';
import { ImgWebp } from '../../commons/ImgWeb';
import { CustomMUIButton } from '../../commons/buttons/CustomMUIButton';
import { ButtonClassNames, GlobalRouteNames } from '../../../models/Common';

export const BrizTvPromo: FC = () => {
  const history = useHistory();
  const { t } = useTranslation();

  const handleClick = () => {
    history.push(GlobalRouteNames.ConnectionBrizTv);
  };

  return (
    <div className="briz-tv-promo card card__primary">
      <div className="briz-tv-promo__header">
        <ImgWebp webpSrc={ClapWebp} fallback={ClapPng} alt="clap" className="briz-tv-promo__header__clap" />
        <ImgWebp
          webpSrc={DogInPoolWebp}
          fallback={DogInPoolPng}
          alt="dog in pool"
          className="briz-tv-promo__header__dog-in-pool"
        />
        <ImgWebp webpSrc={PopcornWebp} fallback={PopcornPng} alt="popcorn" className="briz-tv-promo__header__popcorn" />
      </div>
      <div className="briz-tv-promo__info">
        <article className="home-title">{t('brizTvPromo.watchNewOnlineCinemaBrizTv')}</article>
        <div>
          <ul>
            <li>{t('brizTvPromo.moreThanTvChannelsAndFilmsTVSeriesCartoons')}</li>
            <li>{t('brizTvPromo.pauseRewindAndRecordingFunctions')}</li>
            <li>{t('brizTvPromo.simultaneousViewingOnDevices')}</li>
          </ul>
          <strong className="briz-tv-promo__info__sub-article footnote_after">
            {t('brizTvPromo.tryMaximumPackageBrizTVPremiumPremiumMoviesForFirstDaysForFree')}
          </strong>
        </div>
        <div>
          <div className="briz-tv-promo__info__buttons">
            <CustomMUIButton
              label={t('buttons.activate')}
              handleClick={handleClick}
              className={ButtonClassNames.PrimaryFulfilled}
              isBold
            />
          </div>
          <p className="briz-tv-promo__info__additional-text footnote_before">
            {t('brizTvPromo.freeMeansPaymentForServiceForOneUah')}
          </p>
        </div>
      </div>
    </div>
  );
};
